import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { AtSignIcon, PowerIcon, SettingsIcon, UserIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { getUserInfo, removeToken } from "@/lib/token";
import { LOGIN_URL } from "@/lib/static";
import React from "react";

export const DashboardUser = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    removeToken();
    navigate(LOGIN_URL);
  };

  const userinfo = getUserInfo();
  const [open, setOpen] = React.useState(false);

  return (
    <div className="">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant={"outline"} size={"icon"}>
            <UserIcon />
          </Button>
        </PopoverTrigger>
        <PopoverContent align="end" className="p-0">
          <div className="flex  flex-col">
            <div className="flex items-center gap-3 px-4 py-3">
              <AtSignIcon size={16} />
              <span className="text-sm text-slate-700 capitalize">
                {userinfo?.username}
              </span>
            </div>
            <Separator />

            <Button
              variant={"ghost"}
              className=" gap-3 py-3 h-auto flex justify-start items-center"
              onClick={() => {
                setOpen(false);
                navigate("/profile");
              }}
            >
              <UserIcon size={16} />
              <span className="text-sm text-slate-700 ">My Profile</span>
            </Button>
            <Button
              variant={"ghost"}
              className=" gap-3 py-3 h-auto flex justify-start items-center"
              onClick={() => {
                setOpen(false);
                navigate("/settings");
              }}
            >
              <SettingsIcon size={16} />
              <span className="text-sm text-slate-700 ">Settings</span>
            </Button>
            <Separator />
            <Button
              variant={"ghost"}
              className=" gap-3 py-3 h-auto flex justify-start items-center"
              onClick={handleLogout}
            >
              <PowerIcon size={16} />
              <span className="text-sm text-slate-700 ">Logout</span>
            </Button>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
